import React, { FC, ReactNode } from 'react';
import { TreeHierarchy } from '../checkbox-tree/checkboxNodeField';
import CheckboxTree from '../checkbox-tree/checkboxTree';

interface AccessAreaDetailsProps {
    tree: TreeHierarchy | undefined,
    onCheck?: (node: TreeHierarchy, fieldValues) => void,
    onToggleExpand?: (node: TreeHierarchy) => void,
    children?: ReactNode;
}

const AccessAreaDetails: FC<AccessAreaDetailsProps> = ({ tree, onCheck, children, onToggleExpand }) => {
    return <div>
        <CheckboxTree tree={tree} onCheck={onCheck} onToggleExpand={onToggleExpand}></CheckboxTree>
        {children}
    </div>;
};

export default AccessAreaDetails;
